import { type RPPCore } from '@retailer-platform/dashboard/app'
import ReportsDomain from '@retailer-platform/domain-reports/domainDefinition'
import YodaRulesDomain from '@retailer-platform/domain-yoda-rules/domainDefinition'
import OauthApplicationsDomain from '@retailer-platform/domain-oauth-applications/domainDefinition'
import PartnerConfigurationsDomain from '@retailer-platform/domain-partner-configurations/domainDefinition'
import CustomersAndOrdersDomain from '@retailer-platform/domain-customers-and-orders/domainDefinition'
import LoyaltyDomain from '@retailer-platform/domain-loyalty/domainDefinition'
import ExternalHealthDashboardDomain from '@retailer-platform/domain-external-health-dashboard/domainDefinition'
import MassopsDomain from '@retailer-platform/domain-massops/domainDefinition'
import PartnerManagementDomain from '@retailer-platform/domain-partner-management/domainDefinition'
import StorefrontShortcutsBarDomain from '@retailer-platform/domain-storefront-shortcuts-bar/domainDefinition'
import RetailerContactDomain from '@retailer-platform/domain-retailer-contact/domainDefinition'
import QualityScorecardsDomain from '@retailer-platform/domain-quality-scorecards/domainDefinition'
import FulfillmentPartnerIntegrationsDomain from '@retailer-platform/domain-fulfillment-partner-integrations/domainDefinition'
import DeliverySoftwareDomain from '@retailer-platform/domain-delivery-software/domainDefinition'
import MarketingToolingDomain from '@retailer-platform/domain-marketing-tooling/domainDefinition'
import CheckoutDomain from '@retailer-platform/domain-checkout/domainDefinition'
import SearchPlatformDomain from '@retailer-platform/domain-search-platform/domainDefinition'
import CustomStringsDomain from '@retailer-platform/domain-custom-strings/domainDefinition'
import FulfillmentSettingsDomain from '@retailer-platform/domain-fulfillment-settings/domainDefinition'
import CatalogHealthDomain from '@retailer-platform/domain-catalog-health/domainDefinition'
import AioliDomain from '@retailer-platform/domain-aioli/domainDefinition'
import IppNavIntrospectDomain from '@retailer-platform/domain-ipp-nav-introspect/domainDefinition'
import ItemPriceManagementDomain from '@retailer-platform/domain-item-price-management/domainDefinition'
import AccountManagementBulkDomain from '@retailer-platform/domain-account-management-bulk/domainDefinition'
import IncentiveBudgetsDomain from '@retailer-platform/domain-incentive-budgets/domainDefinition'
import ReceiptsDomain from '@retailer-platform/domain-receipts/domainDefinition'
import SandboxDomain from '@retailer-platform/domain-sandbox/domainDefinition'
import CartAssistantDomain from '@retailer-platform/domain-cart-assistant/domainDefinition'
import SeoDomain from '@retailer-platform/domain-seo/domainDefinition'
import ShoppersAdminDomain from '@retailer-platform/domain-shoppers-admin/domainDefinition'
import InsightsPortalLibDomain from '@retailer-platform/domain-insights-portal-lib/domainDefinition'
// @hygen:inject import-domain

export const registerDomains = (app: RPPCore) => {
  app.attachDomain(ReportsDomain)
  app.attachDomain(YodaRulesDomain)
  app.attachDomain(OauthApplicationsDomain)
  app.attachDomain(PartnerConfigurationsDomain)
  app.attachDomain(CustomersAndOrdersDomain)
  app.attachDomain(LoyaltyDomain)
  app.attachDomain(ExternalHealthDashboardDomain)
  app.attachDomain(MassopsDomain)
  app.attachDomain(PartnerManagementDomain)
  app.attachDomain(StorefrontShortcutsBarDomain)
  app.attachDomain(RetailerContactDomain)
  app.attachDomain(QualityScorecardsDomain)
  app.attachDomain(FulfillmentPartnerIntegrationsDomain)
  app.attachDomain(DeliverySoftwareDomain)
  app.attachDomain(MarketingToolingDomain)
  app.attachDomain(CheckoutDomain)
  app.attachDomain(SearchPlatformDomain)
  app.attachDomain(CustomStringsDomain)
  app.attachDomain(FulfillmentSettingsDomain)
  app.attachDomain(CatalogHealthDomain)
  app.attachDomain(AioliDomain)
  app.attachDomain(IppNavIntrospectDomain)
  app.attachDomain(ItemPriceManagementDomain)
  app.attachDomain(AccountManagementBulkDomain)
  app.attachDomain(IncentiveBudgetsDomain)
  app.attachDomain(ReceiptsDomain)
  app.attachDomain(SandboxDomain)
  app.attachDomain(CartAssistantDomain)
  app.attachDomain(SeoDomain)
  app.attachDomain(ShoppersAdminDomain)
  app.attachDomain(InsightsPortalLibDomain)
  // @hygen:inject attach-domain
}
